import axios from "axios";
import { Global } from "../../config/global";

// handleReconnectionSession = Funcion para iniciar sesion desde el navegador,
// si existe una sesion activa en otro, cerrar sesion en ese navegador e inicar en el actual

export const handleReconnectionSession = async ({ userName, password, idUsuario }) => {
    try {

        let url = Global.url + `user/logout/${idUsuario}`;

        let data = JSON.stringify({
            "username": userName,
            "password": password,
        });

        let config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: url,
            headers: {
                'Content-Type': 'application/json'
            },
            data: data
        };

        const response = await axios.request(config);

        return response.status
    } catch(error) {
        console.log("no se logró cerrar la sesión", error);
    }
};